export const FIGURE = 'figure';
export const DASHBOARD = 'dashboard';
export const ONBOARDING = 'onboarding';
